module.exports = __webpack_public_path__ + "static/media/sk.5fddbb65.webp";